const UPSELLS_ACTIONS = Object.freeze({
  FETCH_UPSELLS_REQUEST: 'FETCH_UPSELLS_REQUEST',
  FETCH_UPSELLS_SUCCESS: 'FETCH_UPSELLS_SUCCESS',
  FETCH_UPSELLS_FAILURE: 'FETCH_UPSELLS_FAILURE',
});

const COLLECTION_ACTIONS = Object.freeze({
  SET_CUSTOM_COLLECTION_DATA: 'SET_CUSTOM_COLLECTION_DATA',
  FETCH_CUSTOM_COLLECTION_REQUEST: 'FETCH_CUSTOM_COLLECTION_REQUEST',
  FETCH_CUSTOM_COLLECTION_SUCCESS: 'FETCH_CUSTOM_COLLECTION_SUCCESS',
  FETCH_CUSTOM_COLLECTION_FAILURE: 'FETCH_CUSTOM_COLLECTION_FAILURE',
  SET_MASTER_PRODUCT_CARD_PRODUCT: 'SET_MASTER_PRODUCT_CARD_PRODUCT',
  SET_MASTER_PRODUCT_CARD_CAROUSEL_INDEX: 'SET_MASTER_PRODUCT_CARD_CAROUSEL_INDEX',
  SET_COLLECTION_STRUCTURED_DATA: 'SET_COLLECTION_STRUCTURED_DATA',
});

const COLLECTION_PAGE_ACTIONS = Object.freeze({
  SET_COLLECTION_PAGE_DATA: 'SET_COLLECTION_PAGE_DATA',
  INIT_COLLECTION_PAGE_FILTERS: 'INIT_COLLECTION_PAGE_FILTERS',
  SET_COLLECTION_PAGE_FILTER: 'SET_COLLECTION_PAGE_FILTER',
  CLEAR_COLLECTION_PAGE_FILTERS: 'CLEAR_COLLECTION_PAGE_FILTERS',
  EXPAND_COLLECTION_PAGE_FILTER: 'EXPAND_COLLECTION_PAGE_FILTER',
  OPEN_COLLECTION_PAGE_FILTER_DRAWER: 'OPEN_COLLECTION_PAGE_FILTER_DRAWER',
  CLOSE_COLLECTION_PAGE_FILTER_DRAWER: 'CLOSE_COLLECTION_PAGE_FILTER_DRAWER',
  TRACK_COLLECTION_PILL_TOGGLE_CLICK: 'TRACK_COLLECTION_PILL_TOGGLE_CLICK',
});

export const PDP_ACTIONS = Object.freeze({
  FETCH_MASTER_PRODUCT_REQUEST: 'FETCH_MASTER_PRODUCT_REQUEST',
  FETCH_MASTER_PRODUCT_SUCCESS: 'FETCH_MASTER_PRODUCT_SUCCESS',
  FETCH_MASTER_PRODUCT_FAILURE: 'FETCH_MASTER_PRODUCT_FAILURE',

  SET_PRODUCT_DATA: 'SET_PRODUCT_DATA',

  SET_CURRENT_PRODUCT: 'SET_CURRENT_PRODUCT',

  SET_INITIAL_PRODUCT: 'SET_INITIAL_PRODUCT',

  SET_CURRENT_ATTRIBUTE_INDEX: 'SET_CURRENT_ATTRIBUTE_INDEX',

  SET_CURRENT_SIZE: 'SET_CURRENT_SIZE',

  SET_CURRENT_MAIN_CAROUSEL_SLIDE: 'SET_CURRENT_MAIN_CAROUSEL_SLIDE',

  SET_CURRENT_THUMBNAIL_CAROUSEL_SLIDE: 'SET_CURRENT_THUMBNAIL_CAROUSEL_SLIDE',

  TRACK_PDP_PRODUCT_SELECTOR_CAROUSEL_SCROLL: 'TRACK_PDP_PRODUCT_SELECTOR_CAROUSEL_SCROLL',
  TRACK_PRODUCT_UPDATES_TOOLTIP_VIEW: 'TRACK_PRODUCT_UPDATES_TOOLTIP_VIEW',
  TRACK_VIEW_HIGHLIGHTS_CLICK: 'TRACK_VIEW_HIGHLIGHTS_CLICK',
  TRACK_VIEW_DIFFERENTIATORS_CLICK: 'TRACK_VIEW_DIFFERENTIATORS_CLICK',

  SET_PDP_MODULE_DATA: 'SET_PDP_MODULE_DATA',

  SELECT_QUANTITY: 'SELECT_QUANTITY',
  SET_PDP_VIDEO_MODAL_URL: 'SET_PDP_VIDEO_MODAL_URL',

  TRACK_CLOSE_ADD_TO_CART_MODAL: 'TRACK_CLOSE_ADD_TO_CART_MODAL',

  TRACK_STORE_INVENTORY_DROPDOWN_ACTION: 'TRACK_STORE_INVENTORY_DROPDOWN_ACTION',
  TRACK_STORE_INVENTORY_MODAL_ACTION: 'TRACK_STORE_INVENTORY_MODAL_ACTION',
});

const AJAX_CART_ACTIONS = Object.freeze({
  INIT_CART_REQUEST: 'INIT_CART_REQUEST',
  INIT_CART_SUCCESS: 'INIT_CART_SUCCESS',
  INIT_CART_FAILURE: 'INIT_CART_FAILURE',

  ADD_LINE_ITEMS_REQUEST: 'ADD_LINE_ITEMS_REQUEST',
  ADD_LINE_ITEMS_SUCCESS: 'ADD_LINE_ITEMS_SUCCESS',
  ADD_LINE_ITEMS_FAILURE: 'ADD_LINE_ITEMS_FAILURE',

  UPDATE_LINE_ITEM_REQUEST: 'UPDATE_LINE_ITEM_REQUEST',
  UPDATE_LINE_ITEM_SUCCESS: 'UPDATE_LINE_ITEM_SUCCESS',
  UPDATE_LINE_ITEM_FAILURE: 'UPDATE_LINE_ITEM_FAILURE',

  REMOVE_LINE_ITEM_REQUEST: 'REMOVE_LINE_ITEM_REQUEST',
  REMOVE_LINE_ITEM_SUCCESS: 'REMOVE_LINE_ITEM_SUCCESS',
  REMOVE_LINE_ITEM_FAILURE: 'REMOVE_LINE_ITEM_FAILURE',

  UPDATE_LINE_ITEM_ATTRIBUTES_REQUEST: 'UPDATE_LINE_ITEM_ATTRIBUTES_REQUEST',
  UPDATE_LINE_ITEM_ATTRIBUTES_SUCCESS: 'UPDATE_LINE_ITEM_ATTRIBUTES_SUCCESS',
  UPDATE_LINE_ITEM_ATTRIBUTES_FAILURE: 'UPDATE_LINE_ITEM_ATTRIBUTES_FAILURE',

  UPDATE_CART_ATTRIBUTES_REQUEST: 'UPDATE_CART_ATTRIBUTES_REQUEST',
  UPDATE_CART_ATTRIBUTES_SUCCESS: 'UPDATE_CART_ATTRIBUTES_SUCCESS',
  UPDATE_CART_ATTRIBUTES_FAILURE: 'UPDATE_CART_ATTRIBUTES_FAILURE',

  CLEAR_CART_REQUEST: 'CLEAR_CART_REQUEST',
  CLEAR_CART_SUCCESS: 'CLEAR_CART_SUCCESS',
  CLEAR_CART_FAILURE: 'CLEAR_CART_FAILURE',

  TOGGLE_CART: 'TOGGLE_CART',

  SET_CART_VIEW: 'SET_CART_VIEW',

  SET_CART_MESSAGE: 'SET_CART_MESSAGE',

  SET_CART_CACHE: 'SET_CART_CACHE',

  SET_GIFTING_OPTIONS: 'SET_GIFTING_OPTIONS',
  SET_GIFTING_OPTIONS_SUCCESS: 'SET_GIFTING_OPTIONS_SUCCESS',
  SET_GIFTING_OPTIONS_FAILURE: 'SET_GIFTING_OPTIONS_FAILURE',

  FETCH_CART_UPSELLS_REQUEST: 'FETCH_CART_UPSELLS_REQUEST',
  FETCH_CART_UPSELLS_SUCCESS: 'FETCH_CART_UPSELLS_SUCCESS',
  FETCH_CART_UPSELLS_FAILURE: 'FETCH_CART_UPSELLS_FAILURE',

  SET_RETURNS_INSURANCE_RENDERED: 'SET_RETURNS_INSURANCE_RENDERED',
});

const STOREFRONT_CART_ACTIONS = Object.freeze({
  ADD_DISCOUNT_REQUEST: 'ADD_DISCOUNT_REQUEST',
  ADD_DISCOUNT_SUCCCESS: 'ADD_DISCOUNT_SUCCCESS',
  ADD_DISCOUNT_FAILURE: 'ADD_DISCOUNT_FAILURE',
});

const PAYMENT_SETTINGS_ACTIONS = Object.freeze({
  FETCH_PAYMENT_SETTINGS_REQUEST: 'FETCH_PAYMENT_SETTINGS_REQUEST',
  FETCH_PAYMENT_SETTINGS_SUCCESS: 'FETCH_PAYMENT_SETTINGS_SUCCESS',
  FETCH_PAYMENT_SETTINGS_FAILURE: 'FETCH_PAYMENT_SETTINGS_FAILURE',
});

const APP_ACTIONS = Object.freeze({
  OPEN_MODAL: 'OPEN_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
  TRACK_COMPONENT_MOUNT: 'TRACK_COMPONENT_MOUNT',
  TRACK_NAVIGATION: 'TRACK_NAVIGATION',
});

const MAILING_ACTIONS = Object.freeze({
  SIGN_UP_PRODUCT_UPDATES_REQUEST: 'SIGN_UP_PRODUCT_UPDATES_REQUEST',
  SIGN_UP_NEWSLETTER_REQUEST: 'SIGN_UP_NEWSLETTER_REQUEST',
});

const EXPERIMENTS_ACTIONS = Object.freeze({
  ACTIVATE_EXPERIMENT: 'ACTIVATE_EXPERIMENT',
});

const REVIEWS_ACTIONS = Object.freeze({
  FETCH_PRODUCT_REVIEWS_REQUEST: 'FETCH_PRODUCT_REVIEWS_REQUEST',
  FETCH_PRODUCT_REVIEWS_SUCCESS: 'FETCH_PRODUCT_REVIEWS_SUCCESS',
  FETCH_PRODUCT_REVIEWS_FAILURE: 'FETCH_PRODUCT_REVIEWS_FAILURE',

  FETCH_FILTERED_PRODUCT_REVIEWS_REQUEST: 'FETCH_FILTERED_PRODUCT_REVIEWS_REQUEST',
  FETCH_FILTERED_PRODUCT_REVIEWS_SUCCESS: 'FETCH_FILTERED_PRODUCT_REVIEWS_SUCCESS',
  FETCH_FILTERED_PRODUCT_REVIEWS_FAILURE: 'FETCH_FILTERED_PRODUCT_REVIEWS_FAILURE',

  SET_PRODUCT_REVIEWS_SORT_ORDER: 'SET_PRODUCT_REVIEWS_SORT_ORDER',
  SET_PRODUCT_REVIEWS_SEARCH_TERMS: 'SET_PRODUCT_REVIEWS_SEARCH_TERMS',
  TRACK_PRODUCT_REVIEWS_PAGE_SELECT: 'TRACK_PRODUCT_REVIEWS_PAGE_SELECT',
  OPEN_MOBILE_REVIEW_FILTER_DRAWER: 'OPEN_MOBILE_REVIEW_FILTER_DRAWER',
  CLOSE_MOBILE_REVIEW_FILTER_DRAWER: 'CLOSE_MOBILE_REVIEW_FILTER_DRAWER',
  SET_PRODUCT_REVIEWS_STAR_RATING_FILTER: 'SET_PRODUCT_REVIEWS_STAR_RATING_FILTER',
  SET_PRODUCT_REVIEWS_CUSTOM_QUESTION_FILTER: 'SET_PRODUCT_REVIEWS_CUSTOM_QUESTION_FILTER',
  TRACK_PRODUCT_REVIEWS_FILTERED: 'TRACK_PRODUCT_REVIEWS_FILTERED',
  CLEAR_PRODUCT_REVIEWS_FILTERS: 'CLEAR_PRODUCT_REVIEWS_FILTERS',
});

const GEOFENCING_ACTIONS = Object.freeze({
  FETCH_GEOFENCING_DATA_REQUEST: 'FETCH_GEOFENCING_DATA_REQUEST',
  FETCH_GEOFENCING_DATA_SUCCESS: 'FETCH_GEOFENCING_DATA_SUCCESS',
  FETCH_GEOFENCING_DATA_FAILURE: 'FETCH_GEOFENCING_DATA_FAILURE',
  SET_GEOFENCING_SHOP_SELECTION: 'SET_GEOFENCING_SHOP_SELECTION',
});

const PERSONALIZATIONS_ACTIONS = Object.freeze({
  FETCH_PERSONALIZATIONS_REQUEST: 'FETCH_PERSONALIZATIONS_REQUEST',
  FETCH_PERSONALIZATIONS_SUCCESS: 'FETCH_PERSONALIZATIONS_SUCCESS',
  FETCH_PERSONALIZATIONS_FAILURE: 'FETCH_PERSONALIZATIONS_FAILURE',
  GET_PERSONALIZATION_DATA: 'GET_PERSONALIZATION_DATA',
  TRACK_DY_RECS_CLICK: 'TRACK_DY_RECS_CLICK',
  TRACK_DY_API_CAMPAIGN_ASSIGNMENT: 'TRACK_DY_API_CAMPAIGN_ASSIGNMENT',
  REPORT_DY_RECS_CLICK: 'REPORT_DY_RECS_CLICK',
});

const TOP_NAVIGATION_ACTIONS = Object.freeze({
  SET_TOP_NAVIGATION_DATA: 'SET_TOP_NAVIGATION_DATA',
  SET_CURRENT_TOP_NAVIGATION_NODE: 'SET_CURRENT_TOP_NAVIGATION_NODE',
  TOGGLE_MOBILE_TOP_NAVIGATION: 'TOGGLE_MOBILE_TOP_NAVIGATION',
  CLOSE_TOP_NAVIGATION: 'CLOSE_TOP_NAVIGATION',
  TRACK_BANNER_ARROW_CLICK: 'TRACK_BANNER_ARROW_CLICK',
  TRACK_BANNER_CLICK: 'TRACK_BANNER_CLICK',
  OPEN_SEARCH_QUICK_RESULTS: 'OPEN_SEARCH_QUICK_RESULTS',
  CLOSE_SEARCH_QUICK_RESULTS: 'CLOSE_SEARCH_QUICK_RESULTS',
});

const RETURNS_PAGE_ACTIONS = Object.freeze({
  SUBMIT_RETURNS_PAGE: 'SUBMIT_RETURNS_PAGE',
});

const CATALOG_ACTIONS = Object.freeze({
  SET_CATALOG_PARENT_COLLECTION: 'SET_CATALOG_PARENT_COLLECTION',
  FETCH_CATALOG_MASTER_PRODUCT_REQUEST: 'FETCH_CATALOG_MASTER_PRODUCT_REQUEST',
  FETCH_CATALOG_MASTER_PRODUCT_SUCCESS: 'FETCH_CATALOG_MASTER_PRODUCT_SUCCESS',
  FETCH_CATALOG_MASTER_PRODUCT_FAILURE: 'FETCH_CATALOG_MASTER_PRODUCT_FAILURE',
  FETCH_CATALOG_FINISH: 'FETCH_CATALOG_FINISH',
});

const ANALYTICS_ACTIONS = Object.freeze({
  TRACK_EVENT: 'TRACK_EVENT',
  TRACK_CTA_CLICK_EVENT: 'TRACK_CTA_CLICK_EVENT',
});

const HOMEPAGE_ACTIONS = Object.freeze({
  OPEN_HOMEPAGE_HERO_VIDEO_MODAL: 'OPEN_HOMEPAGE_HERO_VIDEO_MODAL',
});

const COOKIE_CONSENT_ACTIONS = Object.freeze({
  SET_INITIAL_COOKIE_CONSENT_GROUPS: 'SET_INITIAL_COOKIE_CONSENT_GROUPS',
});

const CONTENTFUL_ACTIONS = Object.freeze({
  FETCH_STORE_LOCATION_REQUEST: 'FETCH_STORE_LOCATION_REQUEST',
  FETCH_STORE_LOCATION_SUCCESS: 'FETCH_STORE_LOCATION_SUCCESS',
  FETCH_STORE_LOCATION_FAILURE: 'FETCH_STORE_LOCATION_FAILURE',
});

const ACTIONS = Object.freeze({
  ...AJAX_CART_ACTIONS,
  ...ANALYTICS_ACTIONS,
  ...APP_ACTIONS,
  ...CATALOG_ACTIONS,
  ...COLLECTION_ACTIONS,
  ...COLLECTION_PAGE_ACTIONS,
  ...CONTENTFUL_ACTIONS,
  ...COOKIE_CONSENT_ACTIONS,
  ...EXPERIMENTS_ACTIONS,
  ...GEOFENCING_ACTIONS,
  ...HOMEPAGE_ACTIONS,
  ...MAILING_ACTIONS,
  ...PAYMENT_SETTINGS_ACTIONS,
  ...PDP_ACTIONS,
  ...PERSONALIZATIONS_ACTIONS,
  ...RETURNS_PAGE_ACTIONS,
  ...REVIEWS_ACTIONS,
  ...STOREFRONT_CART_ACTIONS,
  ...TOP_NAVIGATION_ACTIONS,
  ...UPSELLS_ACTIONS,
});

export const CART_VIEWS = Object.freeze({
  OVERVIEW: 'OVERVIEW',
  GIFT_MESSAGE: 'GIFT_MESSAGE',
});

export const ADD_TO_CART_ORIGINS = Object.freeze({
  UPSELL: 'UPSELL',
  CART_UPSELL_V2: 'CART_UPSELL_V2',
  PDP_UPSELL_MODAL: 'PDP_UPSELL_MODAL',
});

export const NAVIGATION_ORIGINS = Object.freeze({
  TOP_NAVIGATION: 'TOP_NAVIGATION',
  BREADCRUMB: 'BREADCRUMB',
  SECONDARY_NAVIGATION: 'SECONDARY_NAVIGATION',
  SEARCH: 'SEARCH',
});

export const GEOFENCING_COOKIES = Object.freeze({
  INFERRED_USER_COUNTRY: 'allbirds-inferred-user-country',
  USER_SELECTED_SHOP: 'allbirds-selected-user-shop',
});

export const IP_COOKIES = Object.freeze({
  USER_IP: 'allbirds-user-ip',
});

export const DYNAMIC_YIELD_COOKIES = Object.freeze({
  SERVER: '_dyid_server',
  SESSION: '_dyjsession',
});

export const SIGNUP_MODAL_COOKIES = Object.freeze({
  SIGNUP_MODAL: 'allbirds-signup-modal',
});

export const TRACKING_COOKIES = Object.freeze({
  ALLBIRDS_EMAIL: 'allbirds-identified-email',
  ALLBIRDS_ENCRYPTED_EMAIL: 'allbirds-encrypted-email',
  ALLBIRDS_ID: 'allbirds_id',
  USER_ID: 'user_id',
  DYNAMIC_YIELD: '_dyjsession',
  DYNAMIC_YIELD_SERVER: '_dyid_server',
  ITERABLE_CAMPAIGN_ID: 'iterable-campaign-id',
  ITERABLE_TEMPLATE_ID: 'iterable-template-id',
  PREFERRED_STORE: 'allbirds-preferred-store',
  USER_STATE: 'allbirds-user-state',
  SESSION_REPLAY_SESSION_ID: 'allbirds-session-replay-session-id',
});

export const USER_SESSION_STATE = Object.freeze({
  ALLBIRDS_SMS_MARKETING_OPT_IN: 'allbirds-sms-marketing-opt-in',
});

export const USER_STATES = Object.freeze({
  LOGGED_IN: 'loggedIn',
  IDENTIFIED: 'identified',
  ANONYMOUS: 'anonymous',
});

export const MODAL_TYPES = Object.freeze({
  ARTICLE_PAGE: 'ARTICLE_PAGE',
  GEOFENCING_SHOP_SELECTOR: 'GEOFENCING_SHOP_SELECTOR',
  HOMEPAGE_HERO_VIDEO: 'HOMEPAGE_HERO_VIDEO',
  LANDING_PAGE_HERO_VIDEO: 'LANDING_PAGE_HERO_VIDEO',
  OUR_COMMITMENT: 'OUR_COMMITMENT',
  PDP_ADD_TO_CART: 'PDP_ADD_TO_CART',
  PDP_COLORWAY_UPDATE_FORM: 'PDP_COLORWAY_UPDATE_FORM',
  PDP_SIZE_CHART: 'PDP_SIZE_CHART',
  PDP_STORE_INVENTORY: 'PDP_STORE_INVENTORY',
  PDP_STORY_MODULE: 'PDP_STORY_MODULE',
  PDP_UPDATE_FORM: 'PDP_UPDATE_FORM',
  PDP_UPSELL: 'PDP_UPSELL',
  PDP_VIDEO: 'PDP_VIDEO',
  PDP_ZOOM_VIEW: 'PDP_ZOOM_VIEW',
  NONE: null,
  RETURNS_PAGE: 'RETURNS_PAGE',
  SIGNUP_MODAL: 'SIGNUP_MODAL',
  STORY_CARD: 'STORY_CARD',
  SUSTAINABILITY_PAGE: 'SUSTAINABILITY_PAGE',
  CONSENT_CONFIRMATION: 'CONSENT_CONFIRMATION',
});

export const COMPONENTS = Object.freeze({
  CART_UPSELL: 'CART_UPSELL',
});

export const ADD_TO_CART_ANALYTICS_ORIGINS = Object.freeze({
  PDP: 'Pdp',
  QUICK_ADD: 'Quick Add',
  UPSELL: 'Upsell',
  CART: 'Cart',
});

export default Object.freeze(ACTIONS);
